import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Alert: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.error.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="altTextAlert"
    >
      <title id="altTextAlert">Important</title>
      <path
        d="M11.1142 2.69113L1.76686 20.536C1.41809 21.2018 1.90105 22 2.65269 22H21.3473C22.099 22 22.5819 21.2018 22.2331 20.536L12.8858 2.69113C12.5115 1.97648 11.4885 1.97647 11.1142 2.69113Z"
        stroke={color}
        strokeWidth="2"
      />
      <rect x="11" y="9" width="2" height="7" rx="1" fill={color} />
      <rect x="10.75" y="17" width="2.5" height="2.5" rx="1.25" fill={color} />
    </svg>
  );
};

export default Alert;
